module.exports = __webpack_public_path__ + "static/media/southwestern_college_logo.300d7ba3.png";